<p class='content'> {{toastObj.title | appTf}} </p>
